import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type CreateSeamVisionlineUserRequest = {
  clientId: string
}

const createSeamVisionlineUser = async (data: CreateSeamVisionlineUserRequest) => {
  const response = await authAPI.post('/seam-visionline/users', data)
  return response.data
}

export const useCreateSeamVisionlineUser = () =>
  useMutation({
    mutationFn: createSeamVisionlineUser,
  })
